import React from "react";
import Ornament from "@/components/Ornament";
import Reveal from "@/components/Reveal";

const STAYS = [
  {
    name: "The Fish Hotel",
    desc: "On the Farncombe Estate — the same estate as Foxhill Manor, a short stroll from the reception.",
    link: "https://www.thefishhotel.co.uk/",
    linkLabel: "thefishhotel.co.uk",
  },
  {
    name: "Dormy House",
    desc: "Also on the Farncombe Estate, with a beautiful spa — moments from the reception.",
    link: "https://www.dormyhouse.co.uk/",
    linkLabel: "dormyhouse.co.uk",
  },
  {
    name: "The Lygon Arms",
    desc: "A historic coaching inn in the heart of Broadway village, with a spa and renowned restaurant.",
    link: "https://www.lygonarmshotel.co.uk/",
    linkLabel: "lygonarmshotel.co.uk",
  },
  {
    name: "Russell's of Broadway",
    desc: "A chic restaurant-with-rooms on Broadway's high street.",
    link: "https://www.russellsofbroadway.co.uk/",
    linkLabel: "russellsofbroadway.co.uk",
  },
  {
    name: "The Crown Inn, Blockley",
    desc: "A cosy village inn just around the corner from the church.",
    link: "https://maps.google.com/?q=The+Crown+Inn,+Blockley",
    linkLabel: "View map",
  },
  {
    name: "Foxhill Manor",
    desc: "A small number of rooms at the venue itself — please speak to us directly if you'd like to enquire.",
    link: null,
  },
];

const Accommodation = () => (
  <section id="stay" className="section stay" data-testid="section-stay">
    <Ornament />
    <Reveal as="h2" className="script-h2">
      Accommodation
    </Reveal>
    <Reveal as="p" className="muted center">
      For those wishing to stay nearby, here are some places we love. November is quieter in the
      Cotswolds, but we&apos;d still recommend booking early.
    </Reveal>

    <div className="cards two">
      {STAYS.map((s, i) => (
        <Reveal className="card lift" key={s.name} delay={(i % 2) * 80}>
          <h4>{s.name}</h4>
          <p className="card-note">{s.desc}</p>
          {s.link && (
            <a className="textlink" href={s.link} target="_blank" rel="noreferrer">
              {s.linkLabel} →
            </a>
          )}
        </Reveal>
      ))}
    </div>
  </section>
);

export default Accommodation;
